import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Loading from '../../form/fields/Loading'
import uploadIcon from '../../assets/icons/Upload.svg'
import {
  deleteAbDocument,
  getPatientDocumentsByAb,
  UploadAbDocuments,
} from '../../services/MembershipDetailsService'
import { downloadBase64File, viewBase64File } from './Utils'
import './abMembership.scss'
import { abDocDeleted, abDocDeleteError } from './constants'

interface UploadDocsProps {
  patientId: any
  muhid?: string | number
}

const UploadAbDocs: React.FC<UploadDocsProps> = ({ patientId, muhid }) => {
  const docsRef = useRef<HTMLInputElement | null>(null)
  const [uploadedDoc, setUploadedDoc] = useState<any[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedDocUrl, setSelectedDocUrl] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchPatientDocs = useCallback(async () => {
    setLoading(true)
    const response = await getPatientDocumentsByAb(muhid)
    if (response?.success) {
      setUploadedDoc(response?.data)
      setLoading(false)
    } else {
      setUploadedDoc([])
      setLoading(false)
    }
  }, [muhid])
  useEffect(() => {
    fetchPatientDocs()
  }, [patientId, fetchPatientDocs])

  const handleUploadDoc = async (e: ChangeEvent<HTMLInputElement>) => {
    setLoading(true)
    const files = e.target.files
    if (files?.length) {
      const formData = new FormData()
      formData.append('file', files?.[0])
      const response = await UploadAbDocuments(muhid, formData)
      if (response.success) {
        toast.success('success')
        fetchPatientDocs()
      } else {
        toast.error('Error Occured')
      }
    }
    setLoading(false)
  }
  const handleDelete = async (e: any) => {
    const response = await deleteAbDocument(e, muhid)
    if (response.success) {
      toast.success(abDocDeleted)
      fetchPatientDocs()
    } else {
      toast.error(abDocDeleteError)
    }
  }
  const DocumentModal = () => {
    const handleCloseModal = () => {
      setIsModalOpen(false)
      setSelectedDocUrl('')
    }
    return (
      <div className={`document-modal ${isModalOpen ? 'open' : ''}`}>
        {selectedDocUrl?.endsWith('.pdf') && (
          <div className='document-modal-content'>
            <button className='close-modal-button' onClick={handleCloseModal}>
              Close
            </button>
            <iframe
              src={selectedDocUrl}
              width='100%'
              height='100%'
              title='Document Preview'
            />
          </div>
        )}
      </div>
    )
  }

  const handleIconClick = () => {
    if (docsRef?.current) {
      docsRef?.current?.click()
    }
  }

  return (
    <div className='DocContainer'>
      <div className='mainCard'>
        <h3>
          <div className='docViewBody'>
            <div className='docUploadBtn'>
              <div className='docBody'>
                <label htmlFor='docUrl'>
                  <span className='docUrl'>Documents </span>
                </label>
                <img
                  title='Upload Documents'
                  src={uploadIcon}
                  alt='upload button'
                  onClick={handleIconClick}
                  className='upload-icon'
                />
              </div>
              <input
                id='docUrl'
                ref={docsRef}
                type='file'
                accept='image/*, application/pdf'
                style={{ display: 'none' }}
                onChange={handleUploadDoc}
              />
            </div>
          </div>
        </h3>
        <div className='docView'>
          <ul className='docListView'>
            {uploadedDoc?.length > 0 &&
              uploadedDoc?.map((data: any, index: number) => {
                const serialNumber = index + 1

                return (
                  <li className='docListItem' key={index}>
                    <div className='docItemInfo'>
                      <div className='docItemSerial'>{`${serialNumber} - `}</div>
                      <div className='docItemTitle'>
                        {data?.fileName?.split('/')?.[1]}
                      </div>
                      <div className='docItemButtons'>
                        <button
                          className='docItemButton'
                          onClick={() => viewBase64File(data?.data)}
                        >
                          Preview
                        </button>
                        <button
                          className='docItemButton'
                          onClick={() =>
                            downloadBase64File(
                              data?.data,
                              data?.fileName?.split('/')?.[1]
                            )
                          }
                        >
                          Download
                        </button>
                        <button
                          className='docItemButton'
                          onClick={() => handleDelete(data)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
      {isModalOpen && <DocumentModal />}
      {loading && <Loading />}
    </div>
  )
}

export default UploadAbDocs
